export default __webpack_public_path__ + "static/media/element_55.ffe9455c.webp";